/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICatalogPickerViewProps } from './eve-catalog-picker';

/**
 * ICatalogPickerViewProps.
 * @param props - ICatalogPickerViewProps.
 * @returns - Render Catalog Picker.
 */
export const CatalogPickerViewFunctionComponent: React.FC<ICatalogPickerViewProps> = props => {
    const { catalogPicker } = props;
    return (
        <Module {...catalogPicker}>
            {props.heading}
            {props.paragraph}
            {props.catalogs}
            <div className={'eve-help-wrapper'}>{props.slots.help}</div>
        </Module>
    );
};

export default CatalogPickerViewFunctionComponent;
